import React from "react"
import styled from "styled-components"
import { StyledBaseBubble, StyledChatBubble } from "./ChatBubble"
import { Spacer } from "../atoms/Atoms"
import { useSelector } from "react-redux"
import { getHasInterestAndJourney, getHasPartnerInfo } from "../../../derivedSelectors"
import { getInterest, getJourney } from "../../../reducers/userInfo"
import { JourneySummaryKeys, JourneySummaryPronouns } from "../../../utils/JourneySummaries"
import L10n from "../../../lib/carrot-l10n"
import Helpers, { capitalize } from "../../../utils/Helpers"
import { Link } from "react-router-dom"
import { reportErrorMessage } from "utils/ErrorReporting"
import moment from "moment"
import { Body, BodySmall } from "../atoms/Bodies"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { NoPointerEvents } from "components/views/atoms/NoPointerEvents"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const StyledYourAnswer = styled.div`
  font-family: Publico Text;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 1.5;
  color: black;
`

const BeginYourJourney = () => (
  <Link to="/fle/journey/where-are-you" className="no-underline">
    <StyledBaseBubble className="hover-b--carrot-orange animate-all">
      <H2>{l`journeyModule.yourJourney`}</H2>
      <Spacer height={0.5} />
      <Body color="black-80">{l`journeyModule.answerAFewQuestions`}</Body>
      <Spacer height={1.5} />
      <NoPointerEvents>
        <ArrowLink weight="b" arrowAfter dim={false}>
          {l`journeyModule.whereAreYou`}
        </ArrowLink>
      </NoPointerEvents>
    </StyledBaseBubble>
  </Link>
)

const selectModifyYourJourneyState = (state) => ({
  journey: getJourney(state),
  interest: getInterest(state),
  hasPartner: getHasPartnerInfo(state)
})

const ModifyYourJourney = () => {
  const { journey, interest, hasPartner } = useSelector(selectModifyYourJourneyState)

  let journeySummaryKey
  try {
    journeySummaryKey = JourneySummaryKeys[journey][interest]
  } catch {
    journeySummaryKey = "journalSummary.default"
    reportErrorMessage(`Invalid journey/interest combination: ${journey}/${interest}`)
  }

  const pronounKey = hasPartner ? "plural" : "singular"
  const summaryPronouns = JourneySummaryPronouns[journey]
  const firstPronoun = summaryPronouns.first[pronounKey]
  const secondPronoun = summaryPronouns.second ? summaryPronouns.second[pronounKey] : null

  const yourAnswerText = l(journeySummaryKey, { firstPronoun, secondPronoun })

  return (
    <>
      <H2>{l`journeyModule.yourJourney`}</H2>
      <Spacer height={0.5} />
      <Body color="black-80">{l`journeyModule.yourAnswersToThese`}</Body>
      <Spacer height={1.5} />
      <StyledChatBubble>
        <BodySmall color="black-60">
          {l`journeyModule.yourAnswersAsOf`}
          {Helpers.formatDate(new moment(), "MMMM Do YYYY")}
        </BodySmall>
        <Spacer height={0.5} />
        <StyledYourAnswer>{capitalize(yourAnswerText)}</StyledYourAnswer>
        <Spacer height={0.5} />
      </StyledChatBubble>
      <Spacer height={0.5} />
      <ArrowLink weight="b" arrowAfter to="/fle/journey/where-are-you">
        {l`journeyModule.hasAnythingChanged`}
      </ArrowLink>
    </>
  )
}

const YourJourneyModule = () => {
  const hasInterestsAndJourney = useSelector(getHasInterestAndJourney)

  return (
    <>
      <div className="db dn-ns">
        <Spacer height={1} />
      </div>
      {hasInterestsAndJourney ? <ModifyYourJourney /> : <BeginYourJourney />}
      <Spacer height={1} />
    </>
  )
}

export { YourJourneyModule }
